import { __rest } from "tslib";
import { withWixStyle } from './useWixStyle';
import { withNativeStyle } from './useNativeStyle';
export const themeStrategy = (_a = {}, experiments, isBmPlatform) => {
    var _b;
    var { useWixStyles, useNativeStyles } = _a, rest = __rest(_a, ["useWixStyles", "useNativeStyles"]);
    if (experiments === void 0) { experiments = {}; }
    if (isBmPlatform === void 0) { isBmPlatform = false; }
    const isWithWixStylesEnabled = (_b = experiments === null || experiments === void 0 ? void 0 : experiments.withWixStyles) === null || _b === void 0 ? void 0 : _b.enabled;
    const shouldUseWixStyles = useWixStyles !== null && useWixStyles !== void 0 ? useWixStyles : (isBmPlatform && !!isWithWixStylesEnabled);
    return useNativeStyles ? withNativeStyle(rest) : shouldUseWixStyles ? withWixStyle(rest) : rest;
};
//# sourceMappingURL=themeStrategy.js.map